export const getMarketingButtonStyle = ({ type, isLocked, theme, style, }) => (Object.assign(Object.assign(Object.assign({}, (type === 'navigation' && {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    textAlign: 'center',
    maxWidth: '100%',
})), (isLocked && {
    backgroundColor: theme.colors.grey_3,
    borderColor: theme.colors.grey_3,
    color: theme.colors.white_1,
})), style));
